import { PagingSearch } from "./common"

export class ContentCategory {
    contentCategoryName: string
    contentCategoryNo: number
    contentCategorySubName: string
    contentMasterId: string
    seq: number
    status: string
}
export class ContentMaster {
    contentMasterId: string
    contentMasterName: string
    contentMasterTitle: string
    seq: number
    status: string
}
export class Content {
    contentNo: number
    contentMasterId: string
    contentCategoryNo: number
    contentCategoryName: number
    title: string
    subTitle: string
    description: string //요걸사용
    webDescription: string //요걸사용
    webImagePath: string
    mobileDescription: string
    mobileImagePath: string
    readCount: number
    status: string
    startDate: string
    endDate: string
    userNo: number
    userId: string
    userName: string
    email: string
    tel: string
    regDate: string
    isOpen: boolean
    isChecked: boolean
    files: AttachFile[]
    removeFileNoList: number[]
    answers: Answer[]
    contentAnswerYn: string
    processStatus: string
    processStatusName: string
    selected: boolean = false
}

export class AttachFile {
    contentNo: number
    fileNo: number
    filePath: string
    originFileNm: string
}
export class Answer {
    answer: string
    contentAnswerNo: number
    contentNo: number
    regDate: string
    status: string
    userId: string
    userName: string
    userNo: number
}
export class ContentSearch extends PagingSearch{
    userNo: number
    contentMasterId: string
    contentCategoryNo: number
    statusList: string[]
    processStatus: string
    contentAnswerYn: string
    sortDirection: string
}